import { IncidentModel } from './incident.model';

export class IncidentConvictionOojModel extends IncidentModel {
    public incidentConvictionId: number;
    public citingAgencyTypeId: number;
    public dispositionCodeTypeId: number;
    public accidentTypeId: number;
    public courtOrderedInterlockMonthsTypeId: number;
    public courtActionFlagTypeId: number;
    public courtActionCodeTypeId: number;
    public courtOrderedActionTypeId: number;
    public civilCriminalViolationTypeId: number;
    public drugViolationTypeId: number;
    public courtId: number;
    public plateTypeId: number;
    public vehicleRegistrationJurisdictionId: number;
    public vehicleLicensePlateNumber: string;
    public complaintNumber: string;
    public complaintNumberCount: number;
    public complaintSequenceNumber: number;
    public cdlHolderIndicator = false;
    public underlyingViolationCode: string;
    public vehicleMake: string;
    public driverLicenseClass: string;
    public approximateSpeed: number;
    public lawfulSpeed: number;
    public withdrawalNumberOfMonths: number;
    public commercialMotorVehicleIndicator = false;
    public hazardousMaterialIndicator = false;
    public passengerIndicator = false;
    public courtOrderedIgnitionInterlockDeviceIndicator = false;
    public felonyIndicator = false;
    public alternativeServiceProcessIndicator = false;
    public dispositionDate: any;
    public withdrawalBeginningActionDate: any;
    public withdrawalEndingActionDate: any;
    public restrictionBeginningActionDate: any;
    public restrictionEndingActionDate: any;
    public dateOfExtract: any;
    public citingAgencyTypeDisplayValue: string;
    public dispositionCodeTypeDisplayValue: string;
    public accidentTypeDisplayValue: string;
    public courtOrderedInterlockMonthsTypeDisplayValue: string;
    public courtActionFlagTypeDisplayValue: string;
    public courtActionCodeTypeDisplayValue: string;
    public courtOrderedActionTypeDisplayValue: string;
    public civilCriminalViolationTypeDisplayValue: string;
    public drugViolationTypeDisplayValue: string;
    public plateTypeDisplayValue: string;
    public bac: number;
    public stateNativeCode: string;
    public courtTypeId: number;
    public courtName: string;
    public courtStreetAddress: string;
    public courtCity: string;
    public courtJurisdictionId: number;
    public courtZipCode: string;
    public courtTelephoneNumber: string;
    public underlyingAcdCodeId: number;
    public driverLicenseJurisdictionId: number;
    public driverLicenseNumber: string;
}
